module.exports = __webpack_public_path__ + "img/67_15.e0fa0f8b.png";